import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FirestoreService } from 'src/app/services/firestore.service';

@Component({
  selector: 'app-government-category-list',
  templateUrl: './government-category-list.component.html',
  styleUrls: ['./government-category-list.component.sass']
})
export class GovernmentCategoryListComponent implements OnInit {

  governmentCategoryCol;
  governmentNationalCol;
  governmentLocalCol;
  logoImage: string = "./assets/img/no-logo.png"
  
  constructor(    
    private route: Router,
    public db: FirestoreService
  ) { }
  
  ngOnInit(): void {
    this.governmentNationalCol = this.db.getMainColOrder('governmentCategoryInstitutions', 'priority')
  };

  // Routes
  routeToGovernmentListPage(categoryName){
    this.route.navigateByUrl('governments/'+categoryName, { state: { categoryInstitution: categoryName} });
  }
  routeToGovernmentTerritoryListPage(name){
    this.route.navigateByUrl('provinces/'+name);
  }
  
}
